// extracted by mini-css-extract-plugin
module.exports = {"cms-multicolumn":"MultiColumn__cms-multicolumn___2cTEH"};